import React, { Fragment, useEffect, useRef, useState } from 'react'
import { KTSVG } from '../../../_metronic/helpers';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import fetchAPI from "../../../common/fetchAPI";
import Select, { StylesConfig } from 'react-select';
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';
import { getEmployeesList, setFilters, resetFiltersState } from "./employeeSlice";
import { useTranslation } from "react-i18next";

const EmployeeFilters = (props: any) => {
    const { modelRef, t } = props;
    const dispatch = useAppDispatch();

    const { 
        isReload, currentPage, employeeList, pageSize, search, totalItems, 
        isShowGrid, isLoading, start, columnIndex, direction, recordsFiltered, 
        accountemployeeid, sortColumn, sortOrder, IsDisabledValue,
        filterEmployeeName, filterEmailAddress, filterRoleId, filterLocationId, filterDepartmentId, filterStatus
    } = useAppSelector((state) => state.employee);

    const { 
        pageId, menuList, IsList, IsAdd, IsEdit, manageTerminologyList, 
        IsDelete, sessionAccountEmployeeId, enablePasswordComplexity, 
        maxMenuHeight, accountBaseCurrencyId, showCostCenterInTimesheetBy 
    } = useAppSelector((state) => state.globalState);

    
    const [employeeName, setEmployeeName] = useState<string>(filterEmployeeName || '');
    const [emailAddress, setEmailAddress] = useState<string>(filterEmailAddress || '');


    const [roleArray, setRoleArray] = useState<any[]>([]);
    const [selectedOptionRole, setSelectedOptionRole] = useState<any>(null);

    const [locationArray, setLocationArray] = useState<any[]>([]);
    const [selectedOptionLocation, setSelectedOptionLocation] = useState<any>(null);

    const [departmentArray, setDepartmentArray] = useState<any[]>([]);
    const [selectedOptionDepartment, setSelectedOptionDepartment] = useState<any>(null);

    
 const activeInActiveOptions = [
    { label: getValueFromResource('All', dispatch, t), value: -1 },
    { label: getValueFromResource('Active', dispatch, t), value: 0 },
    { label: getValueFromResource('InActive', dispatch, t), value: 1 }
];

const [selectedOptionStatus, setSelectedOptionStatus] = useState<any>(() => {
    const defaultVal = filterStatus !== undefined ? filterStatus : 0;
    return activeInActiveOptions.find(item => item.value === defaultVal) || activeInActiveOptions[1];
});

useEffect(() => {
    const targetStatus = filterStatus !== undefined ? filterStatus : 0; 
    const matchedOption = activeInActiveOptions.find(item => item.value === targetStatus);
    if (matchedOption) {
        setSelectedOptionStatus(matchedOption);
    }
}, [filterStatus]);

    const closeButtonRef = useRef<HTMLButtonElement | null>(null);
    
    const getMasterDataAsync = async () => {
        try {           
            const response = await fetchAPI(`api/V2/Employees/SingleRequest?AccountEmployeeId=${sessionAccountEmployeeId}`, 'GET', '', true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            if (json && json.Data) {                
                const rolesData = json.Data["Active Roles"] ? [...json.Data["Active Roles"]] : [];
                rolesData.forEach((item: any) => {
                    item.value = item.AccountRoleId; 
                    item.label = item.Role;
                });
                rolesData.unshift({ value: 0, label: 'Select' });
                setRoleArray(rolesData);
                
                const locationsData = json.Data["Active Location"] ? [...json.Data["Active Location"]] : [];
                locationsData.forEach((item: any) => {
                    item.value = item.AccountLocationId; 
                    item.label = item.AccountLocation;
                });
                locationsData.unshift({ value: 0, label: 'Select' });
                setLocationArray(locationsData);
             
                const departmentsData = json.Data["Active Departments"] ? [...json.Data["Active Departments"]] : [];
                departmentsData.forEach((item: any) => {
                    item.value = item.AccountDepartmentId; 
                    item.label = item.DepartmentName;
                });
                departmentsData.unshift({ value: 0, label: 'Select' });
                setDepartmentArray(departmentsData);
            }
        } catch (error) {
            console.error("Error loading filters master data:", error);
        }
    }

    useEffect(() => {
        getMasterDataAsync();
    }, []);

    
    useEffect(() => {
        if (roleArray.length > 0) {
            const targetId = filterRoleId !== undefined ? filterRoleId : 0;
            const idx = roleArray.findIndex((item: any) => Number(item.value) === Number(targetId));
            setSelectedOptionRole(idx !== -1 ? roleArray[idx] : roleArray[0]);
        }
    }, [roleArray, filterRoleId]);

    useEffect(() => {
        if (locationArray.length > 0) {
            const targetId = filterLocationId !== undefined ? filterLocationId : 0;
            const idx = locationArray.findIndex((item: any) => Number(item.value) === Number(targetId));
            setSelectedOptionLocation(idx !== -1 ? locationArray[idx] : locationArray[0]);
        }
    }, [locationArray, filterLocationId]);

    useEffect(() => {
        if (departmentArray.length > 0) {
            const targetId = filterDepartmentId !== undefined ? filterDepartmentId : 0;
            const idx = departmentArray.findIndex((item: any) => Number(item.value) === Number(targetId));
            setSelectedOptionDepartment(idx !== -1 ? departmentArray[idx] : departmentArray[0]);
        }
    }, [departmentArray, filterDepartmentId]);

   

    const handleSubmit = () => {   
        const selectedRoleVal = selectedOptionRole?.value ?? 0;
        const selectedLocationVal = selectedOptionLocation?.value ?? 0;
        const selectedDepartmentVal = selectedOptionDepartment?.value ?? 0;
        const selectedStatusVal = selectedOptionStatus?.value ?? 0;
        const filterData = {
            EmployeeName: employeeName || "",
            EmailAddress: emailAddress || "",
            RoleId: Number(selectedRoleVal),
            LocationId: Number(selectedLocationVal),
            DepartmentId: Number(selectedDepartmentVal),
            IsDisabled: Number(selectedStatusVal)
        };
        dispatch(setFilters(filterData));
        const payload = {
            currentPage: 1, 
            pageSize: pageSize ?? 10,
            start: 0,
            order: columnIndex ?? 0,
            orderDir: direction ?? "asc",
            search: search || " ",
            accountemployeeid: accountemployeeid,
            sortColumn: sortColumn,
            sortOrder: sortOrder,
            ...filterData
        };           
        dispatch(getEmployeesList(payload));
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }

    const handleReset = () => {
        setEmployeeName('');
        setEmailAddress('');        
        setSelectedOptionRole(roleArray.find(item => item.value === 0) || null);
        setSelectedOptionLocation(locationArray.find(item => item.value === 0) || null);
        setSelectedOptionDepartment(departmentArray.find(item => item.value === 0) || null);
        setSelectedOptionStatus(activeInActiveOptions.find(item => item.value === 0) || activeInActiveOptions[1]);
        dispatch(resetFiltersState());
        const resetPayload = {
            currentPage: 1, 
            pageSize: pageSize ?? 10,
            start: 0,
            order: columnIndex ?? 0,
            orderDir: direction ?? "asc",
            search: search || " ",
            accountemployeeid: accountemployeeid,
            sortColumn: sortColumn,
            sortOrder: sortOrder,
            EmployeeName: "",
            EmailAddress: "",
            RoleId: 0,
            LocationId: 0,
            DepartmentId: 0,
            IsDisabled: 0 
        };
        dispatch(getEmployeesList(resetPayload));        
        if (closeButtonRef.current) {
            closeButtonRef.current.click();
        }
    }

    
    return (
        <>
            <div className='card-body' style={{ overflowY: 'auto' }}>
                
              
                <div className="col-md-12 mb-4">
                    <label className="fs-7 fw-normal mb-2">
                        {getValueFromResource('Employee Name', dispatch, t)}
                    </label>
                    <input
                        type="text"
                        className="form-control fs-7 fw-normal"
                        placeholder={getValueFromResource('Enter Employee Name', dispatch, t)}
                        value={employeeName}
                        onChange={(e) => setEmployeeName(e.target.value)}
                    />
                </div>

                <div className='row spacingBetweenRows mb-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {getValueFromResource('Email Address', dispatch, t)}
                        </label>
                        <input
                            type="email"
                            className="form-control fs-7 fw-normal"
                            placeholder={getValueFromResource('Enter Email Address', dispatch, t)}
                            value={emailAddress}
                            onChange={(e) => setEmailAddress(e.target.value)}
                        />
                    </div>
                </div>

                
                <div className='row spacingBetweenRows mb-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {getValueFromResource('Role', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionRole}
                            id="RoleId"
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="RoleId"                                                                
                            onChange={(opt) => setSelectedOptionRole(opt)}
                            options={roleArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>

               
                <div className='row spacingBetweenRows mb-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {getValueFromResource('Location', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionLocation}
                            id="LocationId"
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="LocationId"                                                                
                            onChange={(opt) => setSelectedOptionLocation(opt)}
                            options={locationArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>

                
                <div className='row spacingBetweenRows mb-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {getValueFromResource('Department', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionDepartment}
                            id="DepartmentId"
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="DepartmentId"                                                                
                            onChange={(opt) => setSelectedOptionDepartment(opt)}
                            options={departmentArray}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>

                
                <div className='row spacingBetweenRows mb-4'>
                    <div className="col-md-12">
                        <label className="fs-7 fw-normal mb-2">
                            {getValueFromResource('Status', dispatch, t)}
                        </label>
                        <Select
                            value={selectedOptionStatus}
                            id="IsDisabled"
                            className="basic-single fs-7 fw-normal"
                            classNamePrefix="select"
                            isSearchable={true}
                            name="IsDisabled"
                            onChange={(opt) => setSelectedOptionStatus(opt)}
                            options={activeInActiveOptions}
                            styles={dropDownSelectionStyles}
                            maxMenuHeight={maxMenuHeight}
                        />
                    </div>
                </div>
            </div>

            
            <div className='card-footer pt-4'>
                <div className='d-flex flex-stack float-end'>
                    <button
                        type="button"
                        className="btn btn-secondary btn-bs-btn-font-weight me-2 btn-sm fs-7"
                        onClick={() => handleReset()}
                    >
                        {getValueFromResource('Reset Filters', dispatch, t)}
                    </button>       
                    <button
                        ref={closeButtonRef}
                        type="button"
                        className="d-none"
                        id='kt_OffCanvas_close'
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        data-kt-element='send'
                        className="btn btn-primary btn-sm fs-7"
                        onClick={() => handleSubmit()}
                    >
                        <i className="bi bi-filter fs-5 me-1"></i>
                        {getValueFromResource('Apply Filters', dispatch, t)}
                    </button>
                </div>
            </div>
        </>
    )
}

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: '100%', minHeight: '36px', height: '36px', padding: '-1px' }),
}

export default EmployeeFilters;